import { useQuery } from "@tanstack/react-query";

import { getPerformanceMetrics } from "../../../../api/getPerformanceMetrics";
import { getTotalCallCount } from "../../../../api/getTotalCallCount";
import { useSalesContext } from "../../../../sales-context/SalesContext";

export const useTotalCallCount = () => {
    const { apiClients } = useSalesContext();
    const { data, isLoading, isError } = useQuery({
        queryKey: [`call-count`],
        queryFn: async () => getTotalCallCount(apiClients.gamification),
        refetchOnWindowFocus: false,
        retry: 0,
        gcTime: 0,
    });
    return { data, isLoading, isError };
};

export const usePerformanceMetrics = () => {
    const { apiClients } = useSalesContext();
    const { data, isLoading, isError } = useQuery({
        queryKey: [`performance`],
        queryFn: async () => getPerformanceMetrics(apiClients.gamification),
        refetchOnWindowFocus: false,
        retry: 0,
        gcTime: 0,
    });
    return { data, isLoading, isError };
};
